import type { PhoneAlpha2 } from './types'

// Top locations for currently registering users
const defaultFirstLocations: PhoneAlpha2[] = [
  // Order here is not displayed to the user (will be alphabetized per locale)
  'US', // United States
  'BR', // Brazil
  'GB', // United Kingdom
  'MX', // Mexico
  'AR', // Argentina
  'CA', // Canada
  'FR', // France
  'AU', // Australia
  'IT', // Italy
  'DE', // Germany
  'JP', // Japan
  'PH', // Philippines
  'ZA', // South Africa
]

export default defaultFirstLocations
